import React from 'react';
import { useTranslation } from 'react-i18next';
import { isMobileView } from 'src/utils/util';
import { getTranslation } from './utils/util';
import Button from 'src/common/refactoredComponents/button/Button';
import PageLevelMessage from 'src/common/refactoredComponents/pageLevelMessage';
import { ButtonStyles } from 'src/constants/buttonStyles';
import { MainContainer, Title } from '../index.styled';
import SuccessTickIcon from 'src/assets/images/success_tick.svg';
import { BASE_TEXT_PX, LARGE_TEXT_PX } from 'src/styles/fonts/MCFontConstants';

const SuccessMessage = ({ onClose, japaneseTranslations, isLanguageChanged }) => {
    const { t } = useTranslation();
    const isMobile = isMobileView();

    return (
        <MainContainer>
            <Title>
                Report Issue
            </Title>
            <PageLevelMessage
                status="reportIssue"
                message={getTranslation(t, 'reportIssue.reportSuccessTitle', isLanguageChanged, japaneseTranslations, 'Success')} 
                successMessage={getTranslation(t, 'reportIssue.reportSuccessMessage', isLanguageChanged, japaneseTranslations, 
                    'The MyCASE support team will review the issue and provide a response. Thank you!')}
                isFromReportIssue
                messageTextAlign="left"
                // messagewhiteSpace="nowrap" 
                cursor="pointer"
                imgSrc={SuccessTickIcon} 
                imageContainerWidth={!isMobile ? '60px' : ''}
                headerFontSize={LARGE_TEXT_PX}
                messageFontSize={BASE_TEXT_PX}
                marginTop={'20px'}
                boxShadow={'0px 0px 6px rgba(0,0,0,0.16)'}
            />
            <Button
                id={'report-issue-close-button'}
                show={true}
                variant={ButtonStyles.primary}
                height={'38px'}
                mobileWidth={'80px'}
                clicked={onClose}
                fontSize={BASE_TEXT_PX}
                padding='8px 12px'
                margin={'10px 0px 0px 0px'}
                alignSelf={'flex-end'}
            >
                {getTranslation(t, 'reportIssue.close', isLanguageChanged, japaneseTranslations, 'Close')}
            </Button>
        </MainContainer>
    );
};

export default SuccessMessage;
